import React from 'react';

export default function Blog() {
  return (
    <section id="blog" className="blog">
      <h2 className="section-title">הבלוג שלנו</h2>
      <p className="section-subtitle">כל מה שרציתם לדעת על הקפה של צ׳יבו</p>

      <article className="blog-article">
        <h3 className="article-title">
          הסיפור של Tchibo: איך חברת קפה מהמבורג כבשה את העולם
        </h3>
        <p className="article-meta">קריאה של 5 דקות</p>

        <div className="article-body">
          <h4>ההתחלה: המבורג, 1949</h4>
          <p>
            הסיפור של Tchibo מתחיל בהמבורג של אחרי המלחמה. בשנת 1949, מקס הרץ
            (Max Herz) החליט לעשות משהו שנחשב מטורף באותה תקופה — למכור פולי
            קפה טריים בדואר, ישירות הביתה ללקוחות. השם Tchibo הוא שילוב של שם
            השותף שלו, קארל צ׳ילינג-הירין (Carl Tchilling-Hiryan), עם המילה
            הגרמנית Bohne — פול. פשוט: Tchi + Bo. פולי קפה של צ׳ילינג.
          </p>

          <h4>הרעיון שהיה לפני הזמן</h4>
          <p>
            בתקופה שבה קפה היה מוצר גנרי שנקנה בסופר ועמד על המדף חודשים, הרץ
            הבין שטריות זה הכל. הוא קלה את הפולים במנות קטנות ושלח אותם ישירות
            ללקוחות, כשהם עדיין בשיא הטריות. הקונספט הזה — קלייה טרייה, אריזה
            מיידית, משלוח ישיר — הוא בדיוק מה שעולם הקפה המודרני אימץ עשרות שנים
            מאוחר יותר.
          </p>

          <h4>מחנות קפה לאימפריה</h4>
          <p>
            בשנות ה-50 נפתחו חנויות Tchibo הראשונות ברחבי גרמניה. אבל הן לא
            היו סתם חנויות קפה. הרץ הבין שאנשים שנכנסים לקנות קפה ישמחו גם
            לגלות מוצרים מעוצבים באיכות גבוהה. כך נולד הקונספט הייחודי: כל שבוע,
            קולקציה תמטית חדשה לגמרי של מוצרים — מביגוד ועד כלי מטבח, מציוד
            ספורט ועד אלקטרוניקה — לצד הקפה. זה מה שהופך את הכניסה לחנות Tchibo
            לחוויה. אתה בא בשביל שקית פולים ויוצא עם סט מגבות וג׳קט גשם.
          </p>

          <h4>הקלייה: מה הופך את הקפה של צ׳יבו למיוחד</h4>
          <p>
            Tchibo היא כיום מהקלייניות הגדולות בעולם — הרביעית בגודלה. אבל גודל
            לא אומר ויתור על איכות. הפולים נבחרים ממטעים באתיופיה, ברזיל, קולומביה
            וגואטמלה, עם דגש על מסחר הוגן וחקלאות בת-קיימא.
          </p>
          <p>
            הסוד הוא בקלייה האיטית. בעוד מותגים רבים עוברים לקלייה מהירה
            בטמפרטורות גבוהות (שיכולה לשרוף את הפולים ולהשאיר טעם מר), Tchibo
            דבקה בשיטת הקלייה הגרמנית המסורתית — תהליך ארוך ואיטי יותר
            בטמפרטורות מבוקרות. התוצאה: פולים שמגיעים לעומק טעם שלם — שוקולדי,
            חלק, עם חמיצות עדינה ומאוזנת, בלי מרירות.
          </p>

          <h4>100% ערביקה, בלי פשרות</h4>
          <p>
            כל המוצרים הדגל של Tchibo עשויים מ-100% פולי ערביקה. זה לא מובן
            מאליו — הרבה מותגים מערבבים פולי רובוסטה (הזולים יותר) כדי להוריד
            עלויות. ערביקה נותנת טעם עדין יותר, מורכב יותר, עם מתיקות טבעית
            שרובוסטה פשוט לא יכולה לספק.
          </p>

          <h4>שלושת הדגלים שלנו</h4>
          <p>
            <strong>Barista Espresso</strong> — הדגל הכבד. קלייה כהה שמוציאה
            שוקולד מריר, אגוזיות וקרמה עבה. מושלם לאספרסו ולמכונות אוטומטיות.
          </p>
          <p>
            <strong>Caffè Crema Vollmundig</strong> — ה״פולמונדיג״ בגרמנית זה
            ״מלא בפה״, ובצדק. קפה מאוזן עם גוף מלא, סיומת של שוקולד מריר
            ותחושת פה עגולה ונעימה. מתאים לכל שעה ביום.
          </p>
          <p>
            <strong>Barista Caffè Crema</strong> — העדין מבין השלושה. קלייה בהירה
            יותר שנותנת טעם פירותי, קרמה קטיפתית ואסיד עדין ומרענן. הבחירה
            המושלמת למי שאוהב קפה קליל ומתוחכם.
          </p>

        </div>
      </article>
    </section>
  );
}
